module.exports = __webpack_public_path__ + "static/img/09.b39c9d28.png";